import Block from '@components/Layout/Block';
import { color, font, query } from '@design/templateFns';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

const StatBlockContent = ({ selectedStats, count }) => {
  const t = useTranslations();
  return (
    <Block>
      <Wrapper>
        {selectedStats.map((stat, i) => (
          <InfoText key={`stat-${i}`} $count={count}>
            {stat.count}+<InfoLabel> {t(stat.title)} </InfoLabel>
          </InfoText>
        ))}
      </Wrapper>
    </Block>
  );
};

export default StatBlockContent;

/*** STYLING ***/
const Wrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  @media (${query.below('tablet')}) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

const InfoText = styled.div<{ $count: string }>`
  ${font('headline-xl')};
  color: ${color('fg')};
  text-align: center;
  font-size: 40px;
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 60px;
  }
  @media (${query.below('tablet')}) {
    width: ${({ $count }) => ($count == 'odd' ? '100%' : ' 50%')};
    margin-bottom: 40px;
  }
`;
const InfoLabel = styled.div`
  ${font('body-lg')};
  @media (${query.below('tablet')}) {
    font-size: 14px;
  }
`;
